<template>
  <div data-test="until">
    <label class="text-sm font-semibold test-gray-700">Until</label>
    <div class="flex flex-col space-y-2">
      <m-radio-item
        v-for="(option, idx) in options"
        :key="idx"
        :id="`option-until-${idx}`"
        :option="option"
        v-model="until.selection"
      >
        <span v-if="option.input === 'account'">
            {{ option.label }}
            <m-input-dollar
              :id="`next-review-${idx}-input`"
              v-model="until.inputValue"
              class="ml-1 inline-block"
            />
          </span>
      </m-radio-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'until',
  props: {
    selections: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      until: {
        selection: '',
        inputValue: 0,
      },
    };
  },
  computed: {
    options() {
      const { selections } = this;
      return selections.map((selection) => {
        if (selection.rules[0].until.input === 'account') {
          return {
            ...selection.rules[0].until,
            value() {
              return `${this.label}`;
            },
          };
        }
        return {
          value: () => selection.label,
        };
      });
    },
  },
  watch: {
    value: {
      handler(value) {
        this.until = value;
      },
      immediate: true,
    },
    until: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },

};
</script>
